/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type MSTeamsEntity = {
    id: string;
    name: string;
    /**
     * * `user` - USER
     * * `group` - GROUP
     */
    type: MSTeamsEntity.type;
    displayName?: string | null;
    image?: Array<number> | null;
    email?: string | null;
};

export namespace MSTeamsEntity {

    /**
     * * `user` - USER
     * * `group` - GROUP
     */
    export enum type {
        USER = 'user',
        GROUP = 'group',
    }


}

